import styled from "styled-components";

const BronzeImage = styled.img`
  width: 16rem;
  margin: 10rem 4rem;
`

export default BronzeImage;
